import React, { useState, useEffect } from "react";
import { Label, Input, Col, Nav } from "reactstrap";
import { message, Card, Image } from "antd";
import { useSelector, useDispatch} from "react-redux";

import avatar from "../../../assets/images/avartar.png";
import { uploadImage, updateUser } from "../../../helpers/helper";
import * as url from "../../../helpers/url_helper";
import { changeAvartarProfile } from "../../actions";
import { getUserIdStorage } from "../../../helpers/common";
import { useUserDetails } from "../../../context/UserDetailContext";

const Profile = () => {
    const dispatch = useDispatch();
    const [src, setSrc] = useState(avatar);
    const { userDetails } = useUserDetails();
    const handleImgChange = async (e) => {
        try {
            const formData = new FormData();
            formData.append("image", e.target.files[0]);
            const resUpload = await uploadImage(formData);
            if (resUpload.status === 1) {
                var url_img = `${process.env.REACT_APP_API_URL}${url.API_IMAGE_GET_BY_ID}/${resUpload.data.imageName}`;
                
                var data_update = {
                    avatar : resUpload.data.imageName
                }
                setSrc(url_img);
                dispatch(changeAvartarProfile(url_img));
                const dataRes = await updateUser(getUserIdStorage(), data_update);
                dataRes.status === 1
					? message.success("Thay đổi ảnh đại diện thành công!")
					: message.error("Thay đổi ảnh đại diện thất bại!");
                
                
            } else {
                message.error("Thay đổi ảnh đại diện thất bại!");
                setSrc(avatar);
            }
        } catch (error) {
            message.error("Bạn không có quyền thay đổi ảnh đại diện!");
            setSrc(avatar);
        }
    };

  
    const { user } = useSelector((state) => ({
        user: state.Profile.user
    }));
    
    useEffect(() => {
        if (user && user.avatar){
            setSrc(`${process.env.REACT_APP_API_URL}/uploads/images/${user.avatar}`);
        }
    }, [user])
    

    return (
        <React.Fragment>
            <Card>
                <Nav className="page-content" display={"flex"}>
                    <Col>
                        <Label for="userName">Tài khoản:</Label>
                        <Input
                            id="userName"
                            name="username"
                            placeholder="Tài khoản"
                            type="text"
                            defaultValue={userDetails?.username}
                            readOnly
                        />
                        <br />
                        <Label for="fullName">Họ và tên:</Label>
                        <Input
                            id="fullName"
                            name="fullname"
                            placeholder="Họ và tên"
                            type="text"
                            defaultValue={userDetails?.fullName}
                            readOnly
                        />
                        <br />
                        <Label for="fullName">Email:</Label>
                        <Input
                            id="email"
                            name="email"
                            placeholder="Email"
                            type="text"
                            defaultValue={userDetails?.email}
                            readOnly
                        />
                        <br />
                        <Label for="phoneNumber">Số điện thoại:</Label>
                        <Input
                            id="phoneNumber"
                            name="phonenumber"
                            placeholder="Số điện thoại"
                            type="text"
                            defaultValue={userDetails?.phoneNumber}
                            readOnly
                        />
                        <br />
                        <Label for="departmentName">Bộ phận:</Label>
                        <Input
                            id="departmentName"
                            name="departmentName"
                            placeholder=""
                            type="text"
                            defaultValue={user.department ? user.department.departmentName : ''}
                            readOnly
                        />
                        <br />
                        <Input
                            type="checkbox"
                            id="activeStatus"
                            name="activestatus"
                            onChange={e => {}}
                            checked={userDetails?.status === 1}
                        />
                        <Label className="active-status">Trạng thái hoạt động</Label>
                        <br />
                        <br />
                        <Label for="createTime">Thời gian tạo:</Label>
                        <Input
                            id="createTime"
                            name="createTime"
                            placeholder="Create time"
                            type="text"
                            defaultValue={Date(userDetails?.createdTime)}
                            readOnly
                        />
                    </Col>
                    <Col className="left-profile ">
                    
                        <Image preview={false} src={src} fallback={avatar} />

                        <div className="custom-file">
                            <input
                                className="form-control"
                                type="file"
                                accept="image/*"
                                onChange={handleImgChange}
                            />
                        </div>
                    </Col>
                </Nav>
            </Card>
        </React.Fragment>
    );
};

export default Profile;
